/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Output } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';
import { ConstructionWorksheetMasterInfo } from '../../../resources/construction-worksheet.model';

@Component({
  standalone: false,
  selector: 'gh-construction-worksheet-top-form',
  templateUrl: 'construction-worksheet-top-form.component.html',
})
export class ConstructionWorksheetTopFormComponent extends AbstractSnapshotFormComponent<ConstructionWorksheetMasterInfo> {
  @Output() search = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  protected buildForm(snapshot: FormStateSnapshot<ConstructionWorksheetMasterInfo>): FormState<ConstructionWorksheetMasterInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      snapshot,
      children: {
        jobId: void 0,
        scheduleId: void 0,
        jobNumber: void 0,
        customerName: { enabled: false },
        siteAddress: { enabled: false },
      },
    });
  }
}
